import { render } from "./ProfileView.vue?vue&type=template&id=5067f1bd&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"

import "./ProfileView.vue?vue&type=style&index=0&id=5067f1bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5067f1bd"]])

export default __exports__